import Vue from "vue";

const showError = (context, response) => {
  context.abAccount.errorMsg = response.msg;
  toastr.error(response.msg);
};

export default (context) => {
  context.airbnbActiveLoading = true;
  let url = "/airbnb/oauth";
  const accountToReconnect = context.abAccount;
  if (accountToReconnect && accountToReconnect.id) {
    url += "?account_to_reconnect=" + accountToReconnect.id;
  }

  return Vue.$http
    .get(url)
    .then((response) => {
      if (response && response.status === 200) {
        window.location.href = response.data.oauth_link;
      } else {
        showError(context, response.data.msg);
      }
    })
    .catch((error) => {
      showError(context, error.response.data.msg);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/airbnb/redirect-oauth.js